export default class RulesValidate {
  /**
   * フィールド入力の最小値または最大値に変換
   * @param {array} rules フィールド エントリ リストの規則
   * @param {boolean} isMax 値は最大です
   * @returns {number} フィールド入力の最小または最大数値
   */
  static getMinMaxValue(rules, isMax = true) {
    for (let key in rules) {
      if (!rules[key]) {
        return 0
      }
      if (isMax && rules[key].indexOf('max') !== -1) {
        const maxRules = rules[key].split(':')
        if (maxRules && maxRules.length <= 1) {
          return 0
        }
        return parseInt(maxRules[1].trim())
      }
      if (!isMax && rules[key].indexOf('min') !== -1) {
        const minRules = rules[key].split(':')
        if (minRules && minRules.length <= 1) {
          return 0
        }
        return parseInt(minRules[1].trim())
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/rules-validate.js